<template>
  <div>
    <div id="scd_schedule-logo">
      <img
        v-if="false"
        src="@/assets/images/logo/logo.png"
        alt="Securamdata"
        style="max-height: 30px"/>
      <!--<span class="text-primary sm:text-3xl text-xl">SECURAMDATA AGENDAMENTO</span>-->
    </div>
    <b-img fluid id="scd_schedule-img" :src="require('@/assets/images/pages/calendar-illustration.png')" />
    <div id="scd_schedule-confirmation" v-if="hash">
      <b-card
        class="h-full"
        header-bg-variant="primary">
        <template #header>
          <span class="text-white text-lg font-bold">SECURAMDATA - Confirmar Agenda</span>
        </template>
        <div class="pt-1">
          <div class="flex flex-col gap-1">
            <div class="_row">
              <span>Prezado(a)
                <span class="text-primary" v-if="activeGuestName">{{ activeGuestName }}</span>
                <span class="text-primary" v-if="activeGuestEmail">{{` <${activeGuestEmail}>`}}</span>
                ,
              </span>
            </div>
            <div class="_row" v-if="eventTitle">
              <span>Você foi convidado(a) para {{ eventTypeLabel }}: <span class="text-primary">{{ eventTitle }}</span></span>
            </div>
            <div class="_row">
              <span>
                <b>Agendado por:</b> {{ eventAuthor }}
              </span>
            </div>
            <div class="_row">
              <span v-if="hasEvent">
                <b>Local:</b> "Esta é uma conferência online."
              </span>
            </div>
            <div class="_row" v-if="eventUrl">
              <span>
                <b>Onde:</b> <a target="_blank" :href="eventUrl"><b>{{$t('click_here')}}</b> para acessar à reunião com a Santa Cruz Consultoria Jurídica e Advocacia</a>
              </span>
            </div>
            <div class="_row" v-if="eventDescription">
              <b>Descrição:</b>
            </div>
            <div class="_row" style="padding-left: 2rem;">
              <div class="simple-content simple-editor" v-html-safe="eventDescription"/>
            </div>
            <div class="_row" v-if="hasEventAttachments">
              <b>Anexos:</b>
            </div>
            <div class="_row" v-if="hasEventAttachments">
              <media-list :show-delete="false" :medias="event.attachments"/>
            </div>
          </div>
          <div class="pt-2">
            <b-table
              :items="eventSuggestions"
              :fields="getSuggestionsTableFields()"
            >
              <template #cell(situation)="{item}">
                <span
                  :class="[
                    {
                      'REJ':'text-danger',
                      'CON':'text-success',
                      'CONREJ':'text-purple',
                      'PEN': hasAnyConfirmedSuggestion ? 'opacity-50' : 'text-warning'
                    }[item.situation]
                  ]"
                >
                <!-- {{item.situation}} -->
                  {{$t(`schedule_guest.situation.${item.situation}`)}}
                </span>
              </template>
              <template #cell(start_at)="{item: {start_at}}">
                <span>{{ formatDate(start_at) }}</span>
              </template>
              <template #cell(finish_at)="{item: {finish_at}}">
                <span>{{ formatDate(finish_at) }}</span>
              </template>
              <template #cell(action)="{item}">
                <template v-if="withinDate(item.start_at, item.finish_at)">

                  <template v-if="!item.rejected">
                    <b-button
                      v-if="!item.scheduled && !hasAnyConfirmedSuggestion"
                      v-ripple.400="'rgba(40, 199, 111, 0.15)'"
                      variant="flat-success"
                      @click="confirmSchedule(item)"
                    >
                      <feather-icon
                        icon="CheckIcon"
                        class="mr-50"
                      />
                      <span class="align-middle">Confirmar</span>
                    </b-button>
                    <b-button
                      v-if="!item.rejected && item.scheduled"
                      v-ripple.400="'rgba(40, 199, 111, 0.15)'"
                      variant="flat-warning"
                      @click="rejectSchedule(item)"
                    >
                      <feather-icon
                        icon="XCircleIcon"
                        class="mr-50"
                      />
                      <span class="align-middle">{{item.scheduled ? 'Desmarcar' : 'Rejeitar'}}</span>
                    </b-button>
                  </template>
                  <template v-else>
                    <b-button
                      disabled
                      v-ripple.400="'rgba(40, 199, 111, 0.15)'"
                      variant="flat-warning"
                    >
                      <feather-icon
                        icon="XCircleIcon"
                        class="mr-50"
                      />
                      <span class="align-middle">Rejeitado</span>
                    </b-button>
                  </template>
                </template>
              </template>
            </b-table>
          </div>
        </div>
        <template #footer>
          <div class="flex flex-row justify-end">
            <div v-if="hasEvent">
              <b-button :disabled="eventRejected" variant="danger" @click="rejectAll">Rejeitar Sugestões</b-button>
            </div>
          </div>
          <page-footer></page-footer>
        </template>
      </b-card>
      <vs-popup title="Confirmar Rejeição de Agenda" :active.sync="showRejectionPopup">
        <div class="w-full pb-2" v-if="!rejectingAll && rejectingSuggestionData">
          {{rejectingSuggestionData}}
        </div>
        <b-form-textarea
          id="textarea"
          v-model="justification"
          :placeholder="rejectingAll ? 'Justifique o motive de não poder participar de nenhum horário' : 'Justifique o motivo de não poder participar neste horário.'"
          rows="4"
          max-rows="6"
        ></b-form-textarea>
        <div class="flex justify-end pt-2">
          <b-button :disabled="!justification" @click="() => confirmRejection(justification)" variant="primary">Confirmar</b-button>
        </div>
      </vs-popup>
    </div>
  </div>
</template>

<script>
import ScheduleEventService from '@/services/api/ScheduleEventService'
import ScheduleGuestService from '@/services/api/ScheduleGuestService'


import {
  BCard,
  BButton,
  BTable,
  BFormTextarea,
  BImg,
} from 'bootstrap-vue'
import MediaList from '@/components/media/MediaList.vue'
import PageFooter from '@/components/PageFooter.vue'

export default {
  data: () => ({
    service: null,
    scheduleGuestService: null,
    event: null,
    showRejectionPopup: false,
    confirmRejection: () => {},
    justification: null,
    rejectingSuggestion: null,
    rejectingAll: false,
  }),

  props: {
    hash: {
      type: String,
      default: null
    }
  },

  components: {
    BImg,
    BCard,
    BButton,
    BTable,
    BFormTextarea,
    MediaList,
    PageFooter
  },

  watch: {
    showRejectionPopup(value) {
      if (!value) {
        this.rejectingAll = false
        this.justification = null
      }
    }
  },

  computed: {
    hasAnyConfirmedSuggestion() {
      return this._.some(this.eventSuggestions, 'scheduled')
    },
    activeGuestName() {
      return (this.event && this.event.active_guest && this.event.active_guest.name) || null
    },
    activeGuestEmail() {
      return (this.event && this.event.active_guest && this.event.active_guest.email) || null
    },
    eventUrl() {
      return (this.event && this.event.url) || null
    },
    eventRejected() {
      return (this.event && this.event.rejected) || false
    },
    eventAuthor() {
      const author_name = this.event && this.event.author_name
      const author_email = this.event && this.event.author_email

      return author_name && author_email ? `${author_name} <${author_email}>` : null
    },
    eventSuggestions() {
      const suggestions = (this.event && this.event.schedule_suggestions) || []
      if (suggestions.some(s => s.scheduled)) {
        return suggestions.filter(s => s.scheduled)
      } else return suggestions
    },
    eventTitle() {
      const title = this.event && this.event.title
      return title || null
    },
    eventDescription() {
      const description = this.event && this.event.description
      return description || null
    },
    eventTypeLabel() {
      const type = (
        this.event && this.event.calendar_type && this.event.calendar_type.name
        || ''
      ).toLowerCase()

      switch (type) {
        case 'reunião':
          return 'a reunião'
        case 'evento':
          return 'o evento'
        default:
          return type
      }
    },
    rejectingSuggestionData() {
      const startAt = (this.rejectingSuggestion && this.rejectingSuggestion.start_at) || null
      const finishAt = (this.rejectingSuggestion && this.rejectingSuggestion.finish_at) || null
      if (startAt && finishAt) {
        return `${this.formatDate(startAt)} - ${this.formatDate(finishAt)}`
      } else {
        return null
      }
    },
    hasEventAttachments() {
      return (this.event && this.event.attachments && this.event.attachments.length > 0)
    },
    hasEvent(){
      return (this.event && this.event.id) || false
    }
  },

  methods: {
    withinDate(start, finish) {
      const startDate = this.$moment(start)
      const finishDate = this.$moment(finish)
      const nowDate = this.$moment()

      return nowDate.isBefore(finishDate)
    },
    load() {
      if (this.hash) {
        this.$vs.loading()
        this.service.get(`/encrypted/${this.hash}`).then(response => {
          this.event = response
        }).finally(() => {
          this.$vs.loading.close()
        })
      }
    },
    refresh() {
      this.load()
    },
    formatDate(timestamp) {
      const format = 'ddd DD/MM/YYYY HH:mm'
      return this.$utils.format.dateWithFormat(timestamp, format)
    },
    getSuggestionsTableFields() {
      return [
        { key: 'situation', label: 'Situação', sortable: false },
        { key: 'start_at', label: 'Data Início', sortable: false },
        { key: 'finish_at', label: 'Data Fim', sortable: false },
        { key: 'action', label: 'Ação', sortable: false, tdClass: "text-right", thClass: "text-center" },
      ]
    },
    isScheduled(item) {
      if (!this.isEmpty(item.scheduled)) {
        return item.scheduled
      }
      return item.guests && item.guests.length > 0
    },
    confirmSchedule(item) {
      this.applyConfirmSchedule(item)
    },
    applyConfirmSchedule(item) {
      this.scheduleGuestService.confirmScheduleEncrypted(this.hash, item.id).then(
        response => {
          item.scheduled = true
          this.suggestionDateListKey++

          this.notifySuccess(this.$vs, 'Confirmação realizada com sucesso!')

          this.refresh()

          this.$emit('change-confirmation', true)
        }
      )
    },
    rejectSchedule(item) {
      this.rejectingSuggestion = item
      this.openRejectionPopup((justification) => {
        this.applyRejectSchedule(item, justification)
      })
    },
    markAllSuggestionsRejected() {
      if (this.event) {
        this.event.rejected = true
      }
      const suggestionsAreValid = (
        this.event &&
        this.event.schedule_suggestions &&
        this._.isArray(this.event.schedule_suggestions) &&
        (this.event.schedule_suggestions.length > 0)
      )
      if (suggestionsAreValid) {
        this.event.schedule_suggestions.forEach((suggestion) => {
          suggestion.scheduled = false
          suggestion.rejected = true
        })
      }
    },
    rejectAll() {
      this.rejectingAll = true
      this.openRejectionPopup((justification) => {
        this.$vs.loading()
        this.scheduleGuestService.rejectEventEncrypted(this.hash, justification).then(
          response => {
            this.markAllSuggestionsRejected()
            this.showRejectionPopup = false
            this.refresh()
            this.notifySuccess(this.$vs, 'Agenda rejeitada com sucesso!')
          },
          error => {
            this.notifyError(this.$vs, "Não foi possível rejeitar a agenda.")
          }
        ).finally(() => {
          this.$vs.loading.close()
        })
      })
    },
    applyRejectSchedule(item, justification = null) {
      this.scheduleGuestService.rejectScheduleEncrypted(this.hash, item.id, justification).then(
        response => {
          this.showRejectionPopup = false

          item.scheduled = false
          item.rejected = true
          this.suggestionDateListKey++

          this.notifySuccess(this.$vs, 'Agendamento desmarcado com sucesso!')
          this.refresh()
        }
      )
    },
    openRejectionPopup(onConfirm) {
      this.showRejectionPopup = true
      this.confirmRejection = onConfirm
    }
  },

  mounted() {
    this.service = ScheduleEventService.build(this.$vs)
    this.scheduleGuestService = ScheduleGuestService.build(this.$vs)

    this.load()
  }
}
</script>

<style lang="scss">
@import 'src/assets/scss/simple-content.scss';

#scd_schedule-logo {
  @apply flex gap-0 flex-wrap justify-center font-bold;
  @screen sm {
    @apply gap-6;
    @apply font-normal;
    padding-top: 0.2rem;
  }
  @screen md {
    @apply justify-start;
  }
  padding-top: 0.5rem;
  padding-left: 0.5rem;
}
#scd_schedule-img {
  position: fixed;
  scale: 1.2;

  right: 0;
  bottom: 0;
}
#scd_schedule-confirmation {
  @apply top-0 bottom-0 right-0 left-0;
  // position: absolute;
  padding: 1% 1%;
  padding-top: 3rem !important;
  @screen sm {
    padding: 1% 5%;
  };
  @screen lg {
    padding: 3% 18%;
  }
  & > .card {
    min-height: 50vh !important;

    & ._row {
      width: 100%;
    }

    & > .card-header {
      padding: 0.5rem 1.5rem;
    }
  }

  & table.b-table {
    & th, td {
      padding: 1px;
      @screen sm {
        padding: 0.72rem 2rem;
      }
    }
  }

  & .card-footer {
    padding: 0.5rem;
    @screen sm {
      padding: 1.5rem;
    }
  }
}

</style>
